// Computador já preparado para vender sem internet (o PDV offline criou o banco dele aqui).
// Só nele as chamadas que seguram a abertura do sistema ganham tempo limite: com a rede pendurada
// (Wi-Fi ligado, sem internet) elas nunca falhavam, e a tela "Sem internet" — e o PDV offline —
// demoravam dezenas de segundos para aparecer. Em computador comum nada muda.
export const computadorDoPdvOffline = () => {
    try {
        return !!localStorage.getItem('pdv_offline_banco')
    } catch (erro) {
        return false
    }
}

// Tempo limite dessas chamadas. Curto de propósito: quem está preparado tem o que mostrar sem o
// servidor (domínio guardado, usuário guardado, PDV offline). Mais curto ainda quando o PDV já viu a
// internet cair (marca de offline/conexao.js): aí é só confirmar depressa e abrir o PDV.
export const ESPERA_DO_PDV_OFFLINE = 4000
export const ESPERA_SEM_INTERNET = 1500

const semInternetMarcado = () => {
    try {
        return localStorage.getItem('pdv_offline_sem_internet') == '1'
    } catch (erro) {
        return false
    }
}

export const esperaDoBoot = () => {
    if (!computadorDoPdvOffline()) {
        return {}
    }
    return { timeout: semInternetMarcado() ? ESPERA_SEM_INTERNET : ESPERA_DO_PDV_OFFLINE }
}
